import React from 'react';
import PropTypes from 'prop-types';

const getStatusStyle = (status) => {
    if (!status) return 'bg-gray-200 text-gray-800';
    
    switch (status.toLowerCase()) {
        case 'active':
            return 'bg-blue-200 text-blue-800';
        case 'in progress':
            return 'bg-yellow-200 text-yellow-800';
        case 'inactive':
            return 'bg-gray-200 text-gray-800';
        case 'pending':
            return 'bg-orange-200 text-orange-800';
        case 'completed':
            return 'bg-green-100 text-green-800';
        case 'scheduled':
            return 'bg-purple-200 text-purple-800';
        case 'cancelled':
            return 'bg-red-200 text-red-800';
        case 'declined':
            return 'bg-red-200 text-red-800';
        default:
            return 'bg-gray-200 text-gray-800';
    }
};

const StatusChip = ({ status = 'Unknown', className = '' }) => {
    return (
        <span className={`px-2 py-1 rounded-full text-sm ${getStatusStyle(status)} ${className}`}>
            {(status || 'Unknown').toUpperCase()}
        </span>
    );
};

StatusChip.propTypes = {
    status: PropTypes.string,
    className: PropTypes.string
};

export default StatusChip; 